import { render, staticRenderFns } from "./ViewDashboard.vue?vue&type=template&id=45f67d48"
import script from "./ViewDashboard.vue?vue&type=script&lang=js"
export * from "./ViewDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports